exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-box[data-v-83fd57b8]{height:calc(100vh - 130px)}\n", ""]);

// exports
